import { MarketCode } from '@prisjakt/web-app-config/dist/markets/types';

export enum ReportType {
  WrongPrice = 'price',
  WrongStockStatus = 'stock',
  WrongProduct = 'wrong_product',
}

export type Metadata = {
  message: string;
  ['agent_type_key']: ReportType;
  uri: string;
  ['country_code']: MarketCode;
  ['store_id']: number;
  ['price_id']: number;
  ['price_value']: string;
  ['stock_status']: string;
};
